import {avatarsClient} from 'common/report/queries/app-api/avatars-client';

import {Store} from './store';

export interface AvatarResults {
  base: string;
  avatars: {[userId: number]: string};
}

export type AvatarURL = string;

export const avatarsStore = new Store<AvatarResults>({
  apiClient: avatarsClient,
  defaultValue: {},
  name: `avatars`,
});
